var map = {
	"./app/core-module/assets/lang/ar.json": "8c71",
	"./app/core-module/assets/lang/en.json": "2d7a",
	"./app/course-module/assets/lang/ar.json": "5e6f",
	"./app/course-module/assets/lang/en.json": "08b8",
	"./app/quiz-module/assets/lang/ar.json": "d6f6",
	"./app/quiz-module/assets/lang/en.json": "d729",
	"./app/user-module/assets/lang/ar.json": "c1de",
	"./app/user-module/assets/lang/en.json": "3fb9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da83";